export default __webpack_public_path__ + "static/media/bitski.94194469.png";